import { useSelector } from 'react-redux';

import { RootState } from 'store';

import {
  MAP_STATE,
  MAP_NAMES
} from '../../constants';

export const useInitializedMap = () => {
  const initializingMap = useSelector((state: RootState) => state[MAP_STATE].initialized);
  return initializingMap;
};

export const useFocusPoint = () => {
  const focusPoint = useSelector((state: RootState) => state[MAP_STATE].focusPoint);
  return focusPoint;
};

export const useRoutesFilter = () => {
  const routesFilter = useSelector((state: RootState) => state[MAP_STATE].routes.filter);
  return routesFilter;
};

export const useShowStreetView = () => {
  const showStreetView = useSelector((state: RootState) => state[MAP_STATE].showStreetView);
  return showStreetView;
};

export const useSelectedPoint = () => {
  const selectedPoint = useSelector((state: RootState) => state[MAP_STATE].selectedPoint);
  return selectedPoint;
};

export const useMapName = () => (
  useSelector((state: RootState) => state[MAP_STATE].name)
);

export const useIsActiveGoogleMap = () => {
  const mapName = useMapName();

  return mapName === MAP_NAMES.google;
};

export const useIsActiveHereMap = () => {
  const mapName = useMapName();

  return mapName === MAP_NAMES.here;
};
